// extracted by mini-css-extract-plugin
export default {"separator":"Component_separator__AyeCp"};